import { BaseModel } from '../../core/abstractions/base.model';

export class ResourceConfigActions extends BaseModel {
    list = 'list';
    search = 'gridsearch';
    get = '';
    add = '';
    edit = '';
    remove = '';

    constructor(init?: Partial<ResourceConfigActions>) {
        super();
        Object.assign(this, init);
    }
}
